import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { IconArrow, rem, Spacer } from 'design-system';
import IconCircle from 'design-system/icons/IconCircle';
import { IconMoneyChange } from 'design-system/icons/IconMoneyChange';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import useColors from 'hooks/useColors';
import useAssetSwitchPicker from '../hooks/useAssetSwitchPicker';
const AssetSwitchEmptyCard = ({ onSelectToAssetId, fromAssetId }) => {
    const colors = useColors();
    const { isPickerOpen, onPress } = useAssetSwitchPicker(fromAssetId, undefined, onSelectToAssetId);
    return (<TouchableBounceCard onDark noMarginTop noMarginBottom style={styles.card} onPress={onPress}>
      <IconCircle width={44} height={44} color={colors.background.brandLight}>
        <IconMoneyChange colorKey="brand"/>
      </IconCircle>
      <Spacer w={16}/>
      <View style={styles.flex}>
        <Text Text-16>Select fund or ETF</Text>
      </View>
      <Spacer w={16}/>
      <IconArrow direction={isPickerOpen ? 'up' : 'down'}/>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    card: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    flex: {
        flex: 1,
    },
});
export default AssetSwitchEmptyCard;
